import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AlertService, PartnerListService } from '../_services';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-partner-new-list',
  templateUrl: './partner-new-list.component.html',
  styleUrls: []
})
export class PartnerNewListComponent implements OnInit {

  dtOptions: DataTables.Settings = {}; 
  dtTrigger = new Subject(); 
  partnerList: any[] = []; 
  closeResult: string; 

  constructor(
              public router: Router,
              private dataService:PartnerListService,
              private alertService: AlertService,
              private modalService: NgbModal
            ) { }
    
  modalReference:NgbActiveModal;
  modalTitle:string;
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.allPartner();
  }

  allPartner(){
    this.loadShow();
    this.dataService.getAllPartner()
        .pipe().subscribe(
          res => { 
            this.partnerList = res['data']
          console.log(this.partnerList,"partnerList");
          this.dtTrigger.next();        
          this.loadHide();
       });
     }

  openPartnerViewPage(slug) {
    this.router.navigate(['partner-view/' + slug]);
  }

  delete(slug){
    if(confirm("Are you sure to delete")) {
      this.dataService.deletePartner(slug)
          .pipe().subscribe(data =>{
            if(data['status']==200){
              this.dtTrigger = new Subject(); //  DataTable
              this.alertService.success('Partner deleted successfully', true);
              this.allPartner();
            }else{
              this.alertService.error('Partner error');
            }
          },error =>{
            this.alertService.error(error);
          });
       }
  }

  loadShow(){
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide(){
    this.showloding = false;
    this.lodingImage = true;
  }

}
